import BankList from '@/views/bank/bank-list.vue';

export default [
    {
        path: '/bank-list',
        component: BankList,
        name: 'bankList'
    },
]